import type { SolicitacaoPagamentoDto } from "@/services/solicitacaoPagamento";
import { currentLocalDateInput } from "@/utils/dateInput";

export interface ArquivadasFilterValues {
  search: string;
  dateFrom: string;
  dateTo: string;
}

export const EMPTY_ARQUIVADAS_FILTERS: ArquivadasFilterValues = {
  search: "",
  dateFrom: currentLocalDateInput(),
  dateTo: currentLocalDateInput(),
};

function itemSearchText(item: SolicitacaoPagamentoDto): string {
  return [
    item.id,
    item.solicitanteName,
    item.creditorName,
    item.descricao,
    item.cancelNote ?? "",
    item.canceladaByName ?? "",
    String(item.valor),
  ]
    .join(" ")
    .toLowerCase();
}

function itemReferenceDate(item: SolicitacaoPagamentoDto): string {
  return (item.canceladaAt ?? item.createdAt).slice(0, 10);
}

export function filterSolicitacoesArquivadas(
  items: SolicitacaoPagamentoDto[],
  filters: ArquivadasFilterValues,
): SolicitacaoPagamentoDto[] {
  const q = filters.search.trim().toLowerCase();

  return items.filter((item) => {
    if (q && !itemSearchText(item).includes(q)) return false;

    const ref = itemReferenceDate(item);
    if (filters.dateFrom && ref < filters.dateFrom) return false;
    if (filters.dateTo && ref > filters.dateTo) return false;

    return true;
  });
}
